import styled from 'styled-components';

import { Button } from 'src/app/components/lib/button';
import { LinkButton } from 'src/app/components/lib/button/link-button';

export const SummarySidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 629px;
  height: 100%;
  background-color: var(--color-grayscale-white);
  color: var(--color-grayscale-black);
  overflow-y: auto;
`;

export const SummarySideBarHeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-gray-20);
  width: 100%;
  padding: var(--sizes-20) var(--sizes-60);
  height: 47px;
`;

export const SummarySidebarHeading = styled.div`
  width: 100%;
  font: var(--font-large-16pt-semibold);
  margin: 0;
  line-height: 30px;
`;

export const NoContentBlock = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  font: var(--font-small-13pt-normal);
  height: 80px;
  background-color: var(--color-gray-10);
  align-items: center;
`;

export const SideBarSectionHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 0 var(--sizes-40);
  height: 47px;
`;

export const SideBarSectionHeader = styled.div`
  width: 100%;
  font: var(--font-large-16pt-semibold);
  margin: 0;
  line-height: 30px;
`;

export const StyledLinkButton = styled(LinkButton)`
  color: var(--color-red-50);
`;

export const ButtonMarginLeft = styled(Button)`
  margin-left: var(--sizes-10);
`;

export const SummarySidebarSection = styled.div`
  width: 100%;
  height: 100%;
  gap: 8px;
  padding: var(--sizes-50) var(--sizes-60);
  border-bottom: 1px solid var(--color-gray-20);

  :last-child {
    border-bottom: none;
  }
`;

export const SummaryFieldTitle = styled.div`
  font: var(--font-small-13pt-semibold);
  color: var(--color-grayscale-black);
`;

export const SummaryFieldValue = styled.div`
  font: var(--font-small-13pt-normal);
  color: var(--color-gray-90);
`;
